import React from 'react';
import { Link, Squish, Typography } from '@grubhubprod/gh-cookbook-react';

export interface PaginationLinkProps {
  page: number;
  isActive: boolean;
  disabled: boolean;
  onClick: (page: number) => void;
}

export const PaginationLink: React.FC<PaginationLinkProps> = ({
  page,
  isActive,
  disabled,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    if (!disabled && !isActive) {
      onClick(page);
    }
  };

  return (
    <Link
      href="?"
      onClick={handleClick}
      aria-label={`Page ${page}`}
      disabled={disabled}
    >
      <Squish inset="x-sm">
        <Typography
          fontWeight={isActive ? 'bold' : 'normal'}
          color={isActive ? 'primaryText' : 'interactive'}
        >
          {page}
        </Typography>
      </Squish>
    </Link>
  );
};
